import { render, staticRenderFns } from "./CyberpunkBox.vue?vue&type=template&id=20e3e0b9&scoped=true&"
import script from "./CyberpunkBox.vue?vue&type=script&lang=js&"
export * from "./CyberpunkBox.vue?vue&type=script&lang=js&"
import style0 from "./CyberpunkBox.vue?vue&type=style&index=0&id=20e3e0b9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e3e0b9",
  null
  
)

export default component.exports